export default {
    // common
    yes: '是',
    no: '否',
    cancel: '取消',
    all: '全部',
    athlete: '运动员 | 运动员们',
    coach: '教练员 | 教练员们',
    filter: '过滤',
    closeFilter: '关闭过滤',
    firstName: '名',
    lastName: '姓',
    email: '电子邮件',
    save: '保存',
    clear: '清理',
    submit: '提交',
    loadMore: '读取更多',
    more: '更多',
    everybody: '每个人',
    close: '关闭',
    next: '下一个',
    or: '或者',
    help: '帮助',
    add: '增加',
    create: 'Create',
    update: 'Aktualisieren',
    createAndContinue: 'Speichern und neu hinzufügen',
    finish: 'Finish',
    any: 'Irgendein',
    areYouSureToDeleteThisFile: 'Are you sure you want to delete this file?',
    browse: 'Browse',

    // login and sign up
    login: '登陆',
    loginWithFacebook: '通过Facebook登陆',
    loginWithGoogle: '通过Google登陆',
    invalidEmailAddress: '不正确的电子邮箱',
    emptyPassword: '密码不能为空',
    signUp: '注册',
    forgotPassword: '忘记密码',
    signUpForNewAccount: '或者注册一个新的账号',
    resetPassword: '重置密码',
    repeatPassword: '重复密码',
    backToLogin: '回到登陆界面',
    yourFirstName: '你的名',
    yourLastName: '你的姓',
    yourPassword: '你的密码',
    youEmailAddress: '你的电子邮箱',
    success: '成功',
    iAccept: '我同意',
    termsAndConditions: '规章和条件',
    privacyPolicy: '隐私规章',
    receiveProductUpdates: '获取产品升级信息',
    receiveMarketingUpdates: '获取市场营销信息',
    firstNameIsRequired: '请输入名',
    lastNameIsRequired: '请输入姓',
    passwordIsRequired: '请输入密码',
    passwordConfirmationIsRequired: '请确认你的密码',
    needToAcceptTermsAndConditions: '请接受规章和条件',
    needToAcceptPrivacyPolicy: '请接受我们的隐私信息并且注册',
    successfulSignUp: 'Successful sign up',
    successfulSignUpMessage:
        'You have successfully created an Account in Ludum. Please check your email in order to validate your ' +
        'account and login.',

    // header dropdown
    addMorningMonitoring: '新的早晨监控',
    addDiaryEntry: '新的日记录入',
    newSession: '新训练课',
    newEvent: '新赛事',
    myProfile: '我的概述',
    manageSettings: '管理设置',
    logout: '登出',
    edit: '编辑',
    remove: '去除',
    favourite: '最爱',
    joinAClub: '加入一个俱乐部',
    createClub: '创建一个俱乐部',
    toggleMenu: '切换菜单',
    schedule: '日程',
    hours: '小时',
    minutes: '分钟',

    // side navigation
    home: 'Home',
    dashboard: '开始菜单',
    sessions: '训练课',
    mySquads: '我的训练小组',
    reports: '报告',
    clubMembers: '俱乐部成员',
    facebook: 'Facebook',
    twitter: 'Twitter',
    instagram: 'Instagram',
    allRightsReserved: '版权所有',
    tcs: '条件和限制',
    english: '英语',
    german: '德语/中文？',
    chinese: 'Chinese',
    switchToAdmin: '切换为管理员',

    // settings
    accountDetails: '账号细节',
    integrations: '结合其他平台',
    myClubs: '我的俱乐部',
    billing: '账单',
    requestToJoinClub: '要求加入一个俱乐部',

    // settings - account details
    details: '细节',
    contactNumber: '联系号码',
    secondaryEmail: '次要邮件地址',
    locationAndTimezone: '地点 / 时区',
    gender: '性别',
    height: '高度',
    cm: '厘米',
    male: '男',
    female: '女',
    weight: '重量',
    kg: '千克',
    maxHeartRate: '最大心率',
    selectedClub: '选择俱乐部',
    scull: '双浆',
    sweep: '单浆',
    cox: '舵手',
    bowStarboard: '左浆',
    strokesidePort: '右浆',
    both: '都可以',
    username: '用户名',
    password: '密码',
    oldPassword: '旧密码',
    newPassword: '新密码',
    reenterPassword: '重新输入密码',
    changeImage: '改变图像',
    chooseSide: '选边',
    dataSuccessfullySaved: '数据保存成功',

    // settings - integrations
    thirdParty: '第三方',
    status: 'S状态',
    account: '账号',
    action: '行动',
    connected: '已连接',
    notConnected: '还未连接',
    connect: '连接',
    disconnect: '断开连接',
    floatIntegration: '漂浮式连接',
    garminIntegration: '佳明连接',
    redirectingToIntegrationsPage: '重新引导到连接页面',

    // settings - my clubs
    selectImage: '选择图像',
    club: '俱乐部',
    position: '位置',
    areYouSureToLeaveClub: '确定离开俱乐部么？',
    areYouSureToJoinClub: '确定加入俱乐部么？',
    successfullyLeftClub: '你成功的离开了俱乐部',
    leave: '离开',
    rejoin: '重新加入',
    name: '姓名',
    description: '描述',
    country: '国家',
    searchForClub: '搜索俱乐部',
    noResultsForSearchedTerm: '当前搜索条件下没有结果',
    sendRequest: '发送申请',
    gmt: '金牌时间',
    gmts: '金牌时间',
    clubDetails: '俱乐部细节',
    wb: '世界最好时间',
    gmtDistribution: '金牌时间飞配',

    // settings - club list
    areYouSureToAcceptInvitation: 'Are you sure you want to accept invitation from the club?',
    areYouSureToRejectInvitation: 'Are you sure you want to reject invitation from the club?',

    // settings - edit club - defaults
    defaults: '默认',
    allYourSessionsAreSetTo: '所有训练课都会设置为',
    competitive: '有竞争性',
    nonCompetitive: '没有竞争性',

    // settings-dashboard-add crew auto import
    autoImportValueAutomatic: 'Import Automatically',
    assignManually: 'Assign Manually',
    autoImportValueOff: 'Do not import',
    ignore: '忽略',
    viewAllThirdPartyIntegrations: '查看所有第三方连接',
    connectThirdParties: '连接第三方',
    connectThirdPartiesMessage:
        '连接第三方允许你容易的输入训练课、心率以及其他数据' +
        '我们会把他们连接到你的Ludum账户中，帮助你最大化利用Ludum平台',
    previous: '之前一个',
    actionRequired: '需要行动',
    completedOn: '完成时间为',
    assignDataToSessionOrCreateNewSession: '把这些数据布置到一个已存在的训练课，或者创造一个新的训练课。',
    assignToExistingSession: '布置到已经存在的训练课',
    createNewSession: '创造新的训练课',
    howDidYouFindSession: '如何找到需要的训练课？',
    createSessionAs: '创造新的训练课为...',
    autoImportEmptyAgendaMessage: '你在日历里没有足够的训练课来布置本节训练课。',
    assignToSession: '布置到本节训练课',
    importAsA: '导入为...',
    selectClub: '选择俱乐部',
    assignToClub: '布置到俱乐部',
    doYouWantToCreateCrew: '你想要为本艇组创造自动导入么？',
    waterSessionAutoImportInitialMessage: '请创造一个新艇组并且把你自己布置到里面。',
    waterSessionAutoImportOnSuccessMessage: '自动导入成功。选择动作:',
    goToDashboard: '去开始页面',
    stayOnPage: '停留在本页面',
    noCrew: '没有艇组',

    // squads
    squad: '训练小组 | 训练小组',
    addSquad: '创建训练小组',
    editSquad: '编辑训练小组',
    deleteSquad: '删除训练小组',
    saveSquad: '保存训练小组',
    areYouSureToDeleteSquad: '确定要删除训练小组么',
    squadsCount: '无训练小组 | 训练小组 | 训练小组',
    allSquads: '所有训练小组',
    squadName: '训练小组名称',
    selectBySquad: '根据训练小组选择',
    selectByAthletes: '根据运动员选择',
    selectByIndividuals: '根据个人选择',
    healthy: '健康',
    ill: '生病',
    injured: '受伤',
    assigned: '已布置',
    illBadge: 'Ill',
    injuredBadge: 'Injured',

    // club members
    sortBy: '根据排序',
    invite: '邀请',
    multiInvite: '多个邀请',
    number: '数字',
    dateOfBirth: '生日',
    accept: '接受',
    reject: '不接受',
    bulkAction: '群组处理',
    areYouSureToRemoveMember: '确定移除本成员么？',
    invitee: '被邀请人',
    clubManager: '俱乐部管理',
    acceptAndAssign: '接受&安排',
    editMember: '编辑成员',
    roleInClub: '俱乐部中角色',
    permissionsInClub: '俱乐部中权限',
    inviteMember: '邀请成员',
    sendInvitation: '发送邀请',
    selectRole: '选择角色',
    multiImport: '多项选择',
    uploadFile: '上传文件',
    downloadSample: '下载样本',
    manager: '管理者 | 管理者',
    invited: '已被邀请',
    pending: '处理中',
    left: '剩余',
    removeMember: '移除会员',
    acceptMember: '接受会员',
    rejectMember: '拒绝会员',
    resendInvitation: '重新发送邀请函',
    role: '角色 | 角色',

    // wall posts
    wallPost: 'Wall Post | Wall Posts',
    writeSomething: '写下重要的东西...',
    attachImageOrFile: '加上一个图像/文件',
    post: '发布',
    wrote: '之前写过',
    comment: '评论 | 评论',
    like: '喜欢',
    uploadingFile: '正在上传文件...',
    areYouSureToDeleteWallPost: '确定要删除这个帖子么？',
    file: 'File | Files',
    photo: 'Photo | Photos',
    video: 'Video | Videos',
    document: 'Document | Documents',

    // add morning monitoring
    selectDate: '选择日期',
    wakingHr: '晨醒心率',
    standingHr: '站立心率',
    bpm: '每分钟心率',
    bodyMass: '身体重量',
    hydration: '缺水状态',
    hydrated: '水分补充足够',
    yesterdayTraining: '昨天的训练',
    sleepQuality: '睡眠质量',
    lowScoreEffectedBy: '我的低分是被...干扰的',
    perceivedShape: '状态打分',
    other: '其他',

    // session
    overview: '简介',
    results: '结果',
    crew: '艇 | 艇',
    attendance: '出席',
    addScores: '加入分数',
    attending: '出席了',
    notAttending: '未出席',
    alternative: '更换',
    createdBy: '创造者为',
    lastEditedBy: '最后编辑者为',
    emptyCrewCreateCrew: 'Create crews for this session',
    crewNoResults: 'No results',
    on: '在...',
    areYouSureToDeleteSession: '确定要删除这节训练课么？',
    youHaveChangedYourClub: '你已经改变了你的俱乐部',
    alreadyInCrewOnThisSession: 'Athletes from other crews in this session',

    // session - attendance
    athletesName: '运动员姓名',
    allAttending: '所有出席的运动员',
    allNotAttending: '所有未出席的运动员',
    coachesName: '教练名称',

    // session - overview
    plannedDistance: '计划的距离',
    plannedTime: '计划的时间',
    noOfPieces: '计划的总间歇划数量',
    noOfExercises: '计划的技术训练的数量',
    noOfCrews: '计划的艇的数目',
    rpe: '主观难度指数',
    avgRpe: '平均主观难度指数',
    notSet: '未确定',
    workStructure: '做功结构',
    noWorkStructure: '放松结构',
    createWorkStructure: '创造做功结构',
    exercise: '技术练习 | 技术练习',
    group: '群组 | ',
    total: '总数',
    participants: '参与者',
    addParticipants: '增加参与者',
    noParticipantsInThisSession: '此训练课无参加者',
    addAthletes: '增加运动员',

    // session - crew
    addCrew: '增加艇 | 增加多条艇',
    filterBoats: '过滤艇名',
    filterAthletes: '过滤运动员',
    boatType: '艇别',
    notifyCrew: '通知艇上运动员',
    newCrew: '组新艇',
    crewName: '新组艇名称',
    addFavourite: '加入收藏',
    unassigned: '未被分配',
    recent: '最近',
    favouriteCrewsListEmpty: '收藏组艇列表为空',
    selectABoatFromAbove: '从上面选一条艇',
    copyToAllPieces: '复制到所有间歇划中',
    updateFavouriteCrew: '更新收藏的艇上运动员',
    bow: '船头',
    stroke: '领浆',
    sculler: '双浆',
    undefined: '未定',
    box: '盒子',
    searchForAthletes: 'Add Athlete',
    emptyAthleteSlot: 'Empty seat',
    createCrew: 'Create Crew | Create Crews',
    updateCrew: 'Update Crew | Update Crews',
    swapAthletes: 'Add/Swap Athletes',
    noAthletes: 'No athletes in this group',
    seat: 'SEAT',
    allPieces: 'All pieces',
    selectPieces: 'Select pieces',
    noCrews: 'No crews for this session',
    unassignedCrews: 'Unassigned',
    favouriteCrews: 'Favourite',
    recentCrews: 'Recent',
    assignCrew: 'Assign Crew',
    assignCrews: 'Assign Crews',
    selectCrew: 'Select Crew',
    selectedCrews: 'Selected Crews',
    addMissingAthletes: 'Add missing athletes',
    availableSessions: 'Available sessions',
    crewsNoSessions: 'No sessions available',
    generalNoCrews: 'No crews',

    // session - results
    session: '训练课 | 训练课',
    alternativeOverallSummary: '另外全面总结',
    alternativeType: '另外类型',
    split: '每500米时间 | 每500米时间',
    aveSplit: '平均每500米时间',
    min: '分钟',
    heartRate: '心率',
    gps: 'GPS',
    overall: '全面',
    barGraph: '条形图',
    lineGraph: '线形图',
    time: '时间',
    gpsTime: 'GPS时间',
    bike: '自行车',
    ergo: '测功仪',
    sc: '力量训练',
    swim: '游泳',
    water: '水',
    run: '跑',
    length: '时长',
    score: '分数',
    aveScore: '平均分数',
    rank: '排名',
    aveHr: '平均心率',
    hr: '心率',
    aveWatts: '平均瓦特数',
    watts: '瓦特数',
    aveCadence: '平均踏频',
    cadence: '踏频',
    aveLactates: '平均血乳酸',
    lactates: '血乳酸值',
    lactate: '血乳酸',
    totalTime: '总时间',
    totalDistance: '总距离',
    pace: '速度',
    avePace: '平均速度',
    avePacePiece: '平均做功速度',
    peakPower: '峰值功率',
    rate: '浆频',
    aveRate: '平均浆频',
    aveRpe: '平均主观难度值',
    power: '功率',
    avePower: '平均功率',
    strokeLength: '每浆划距',
    energy: '能量',
    avePeakForce: '平均峰值牛顿数',
    realPeakForcePosition: '真正峰值力量位置',
    dateDone: '完成日期',
    segments: '分段',
    resultsSummary: '结果小结',
    sessionComparisons: '训练课比较',
    scoreComparisons: '训练结果比较',
    values: '值',
    individuals: '个人',
    type: '种类',
    wKg: '瓦特/公斤',
    aveWKg: '平均瓦特/公斤',
    ergoType: '测功仪种类',
    overallSummary: '大略总结',
    liftsByAthlete: '运动员总举重数',
    liftByExercise: '按训练项目举重数',
    set: '组 | 组数',
    rep: '次 | 次数',
    chooseAthlete: '选择运动员',
    totalTonnage: '总吨数',
    totalWeight: '总重量',
    speed: '速度',
    speedMs: '速度（米/秒）',
    aveSpeed: '平均速度',
    maxSpeed: '最大速度',
    maxPace: '最快速度',
    maxHr: '最大心率',
    timeLessThenHalfSecond: '速度低于0.5米/秒的时间',
    crewGmtLevels: '艇组与金牌时间比较',
    percentageInEachGmtLevel: '在各个金牌级别百分比',
    percentageGmt: '百分比（金牌时间百分比）',
    aveTime: '平均时间',
    aveDistance: '平均距离',
    crewsMap: '艇组地图',
    athletesMap: '运动员地图',
    speedGraph: '速度图表',
    sessionHrByLevels: '训练课心率根据级别',
    percentageInEachHrLevel: '在各心率级别的百分比',
    level: '级别',
    showAllAthletes: '展示所有运动员',
    hideAllAthletes: '隐藏所有运动员',
    showAllCrews: '展示所有艇组',
    hideAllCrews: '隐藏所有艇组',
    hideAll: '隐藏所有',
    noResults: '目前没有分数，请添加分数来看结果',
    noHeartRateResults: '目前心率数据还未添加，请添加分数来看结果',
    noFloatResults: '目前流速数据还未添加，请加入数据来看结果',
    noGpsResults: '目前GPS数据还未添加，请加入数据来看结果',

    // session - import data
    importData: '输入数据',
    addIntegration: '加入连接',
    importText: '倒入',
    piece: '做功 | 做功',

    // add score
    addResults: '加入结果',
    saveAndView: '保存并且查看',
    saveScores: '保存结果',
    updateScores: '更新结果',
    result: '结果 | 结果',
    byAthlete: '根据运动员',
    byCrew: '根据艇组',
    didNotAttend: '没有参加训练',
    flag: '旗标',
    distance: '距离',
    noOfAthletes: '运动员的数量',
    noOfCoaches: '教练员的数量',
    data: '数据',
    peakForcePosition: '峰值牛顿数',
    toAddScoresAddCrewsRowing: '增加水上训练课结果来选拔艇组',
    toAddScoresAddCrewsKayakCanoe: '增加水上训练课结果来选拔艇组',
    startTime: '开始时间',
    startDistance: '开始时的距离',
    finishTime: '完成时间',
    finishDistance: '完成时的距离',
    finalTime: '最终时间',
    finalDistance: '最终距离',
    multiSport: '多个项目',
    backToSessionType: '回到训练课内容',
    sessionListIsEmpty: '训练课表目为空',
    noAddScoresStructure: '为了增加分数，请添加训练课结构和参与人员',
    noAddScoresStructureSc: '为了增加分数，请为练习增加训练课结构和参与人员',

    // create session and event
    createSession: '创造训练课',
    editSession: '编辑训练课',
    updateSession: '更新训练课',
    sessionName: '训练课名称',
    work: '做功',
    permission: '权限 | 权限',
    yourSessionWasCreated: '你的训练课已被创造',
    viewSession: '查看训练课细节',
    addMoreDetails: '添加更多的细节',
    addLessDetails: '添加更少的细节',
    location: '地点',
    intensity: '强度 | 强度',
    focus: '训练课注重点 | 训练课注重点',
    addTags: '添加标签',
    selectExercise: '选择训练项目',
    custom: '自定义',
    exerciseName: '训练项目名称',
    lactateTolerance: '耐血乳酸能力',
    addAllScores: '添加所有分数',
    repeat: '重复',
    frequency: '频率',
    daily: '每天',
    weekly: '每周',
    monthly: '每月',
    yearly: '每年',
    every: '每一个',
    onThe: '在...',
    each: '每一个',
    setBySelectingDays: '选择具体日期',
    setByChoosingFrequency: '根据频率选择',
    day: '天 | 天',
    week: '周',
    month: '月',
    year: '年',
    first: '第一',
    second: '第二',
    third: '第三',
    fourth: '第四',
    until: '直到',
    setEndDate: '增添结束日期',
    removeEndDate: '移除结束日期',
    monday: '周一',
    tuesday: '周二',
    wednesday: '周三',
    thursday: '周四',
    friday: '周五',
    saturday: '周六',
    sunday: '周日',
    jan: '一月',
    feb: '二月',
    mar: '三月',
    apr: '四月',
    may: '五月',
    jun: '六月',
    jul: '七月',
    aug: '八月',
    sep: '九月',
    oct: '十月',
    nov: '十一月',
    dec: '十二月',
    single: '单个',
    multiple: '多个',
    variable: '有变化性',
    byDistance: '根据距离',
    byTime: '根据时间',
    repetition: '重复次数 | 重复次数',
    rest: '休息',
    addGroup: '增加训练人群',
    workHeaderMessage: '创造一个收集测功仪上训练结果的空间，你总是可以之后增加内容或者运动员可以增加自己的内容。',
    createEvent: '创建事件',
    editEvent: '编辑事件',
    updateEvent: '更新事件',
    eventName: '竞赛事件',
    yourEventWasCreated: '你的事件已经被创造',
    viewEvent: '观看事件',
    cannotRemove: '不能移除创造者',
    nameGoesHere: '姓名在这里',
    infoTooltipEditSessionText: '这个许可会允许用户修改本训练课。',
    infoTooltipAddAllScoresSessionText: '这个许可会允许用户为每个运动员增加分数。',
    infoTooltipEditEventText: '这个许可会允许用户修改该事件。',

    // repeat session
    allFutureEvents: '所有未来事件',
    onlyThisEvent: '只有这个事件',

    // dashboard
    yourAgenda: '你的计划',
    view: '查看',
    noSessionsComing: '暂时没有训练课，计划下一节训练课',
    mostRecentSession: '最近的训练课',
    yourRecentSessionWillAppearHere: '你最近的训练课会出现在这里',
    activity: '活动',
    today: '今天',
    notification: '消息 | 消息',
    nextSession: '下一节训练课',
    createNextSession: '创建你的下一节训练课',

    // Dashboard - Training Load Scores
    informationAboutScores: '关于训练分数的信息',
    informationAboutScoresTabText:
        '使用你的心率、早晨监控、训练课反馈可以计算有氧训练量分数。在一段时间内这个分数可以帮助你测量和明白什么时候可以增加或者是减少训练量，并且防止受伤。',
    informationAboutScoresTabButton: '连接(外来数据平台)来激活有氧训练量分数',
    informationAboutScoresT2Title: 'ETS分数',
    informationAboutScoresT2Text:
        '在2014年的Rice研究中提出了一个更加详细的计算训练量分数的方式。它更加详细的把高强度训练的影响加入了计算方法中，并且会把多种不同训练方式纳入到此训练量分数的方式中。',
    informationAboutScoresTrimpTitle: 'TRIMP分数',
    informationAboutScoresTrimpText:
        'Banister在1990年发展出了的衡量训练量的方式。这种方式指代在各个训练强度区域里所花的时间来反映训练的强度。',
    informationAboutScoresFosterTitle: 'Foster分数',
    informationAboutScoresFosterText:
        '在2001发布的Foster研究中，提出了一种不需要心率表来计算训练量的方式。此方法为把主观难度指数乘以该训练课的时间。训练课的时间可以通过导入数据/输入训练课的时间。',
    readMore: '阅读更多',
    compareTo: '与...做比较',

    // new dashboard
    clubTraining: '俱乐部训练',
    cardiacTrainingLoad: '训练成绩',
    ct: '长时间训练积累',
    ctl: '有氧训练打分',
    mm: '晨间监控',
    lastWeek: '上周',
    lastMonth: '上个月',
    lastYear: '去年',
    vs: '对比',
    thisWeek: '本周',
    thisMonth: '本月',
    thisYear: '本年',
    profile: '档案',
    dashboardMorningMonitoringMessage:
        '通过记录你的心率、脱水状态' +
        '训练质量、受伤/生病、晨间监控帮助你明白为什么生病和受伤发生并且' +
        '可以根据这些情况调整训练计划',
    dontHaveStatsForSelectedPeriod: '在选择的事件街店内没有早晨监控数据',
    showCharts: '展示图表',
    hideCharts: '隐藏图表',

    // calendar
    addSession: '增加训练课',
    addRecentSession: '增加最近的训练课',
    myFavourites: '我的收藏',
    clubFavourites: '俱乐部收藏',
    allFavourites: '所有收藏',
    areYouSureToDeleteFavourite: '确定要删除这个收藏么？',
    assignMembers: '布置运动员',
    pleaseAssignPermissions: '请给予权限，目前的权限会被替代',
    assignAndAddPermissions: '给予&增加权限',
    sessionDataSavedSuccessfully: '训练课数据保存成功',
    atLeastOneSessionErrorMessage: '在提交之前你需要选择至少一节训练课。',
    note: '笔记 | 笔记',
    assign: '布置',
    loadPastSession: '读取过去的训练课',
    deleteSelectedSessions: '删除选择的训练课',
    showingResultsFrom: '显示以下训练课结果',
    to: '到',
    emptyResultsSet: '清空结果',
    loadFutureSession: '读取未来的训练课',
    areYouSureToDeleteSelectedEvent: '确定删除已选择的事件么？',
    eventsSuccessfullyDeleted: '事件成功删除',
    searchTags: '搜索标签',
    searchAthletes: '搜索运动员',
    date: '日期 | 日期',
    start: '开始',
    end: '结束',
    mySessions: '我的训练课',
    allSessions: '所有训练课',
    sessionType: '训练课种类 | 训练课种类',
    filterResults: '筛选结果',
    allDay: '全天',
    selectAll: '选择所有',
    list: '列表',
    weeklySummary: '每周总结报告',
    trainingType: '训练种类 | 训练种类',
    editSessionPermissionsErrorMessage: '你没有编辑这个训练课的权限',
    editEventPermissionsErrorMessage: '你没有编辑这个事件的权限',
    quickAssign: '快速布置',
    unselectAll: '取消选择所有选项',
    youHaveToSelectSessionFirst: 'You have to select a session first.',
    selectSession: 'Select session',
    doYouWantToCreateSessionOn: 'Do you want to create session on {date}?',

    // Profile
    theirAgenda: '他们的日程',
    noSessionsPlanned: '目前没有计划的训练课',
    noSessionComing: '目前没有训练课，计划你的下一节训练课。',
    morningMonitoring: '早晨监控',
    hrZones: '心率区域',
    todayMorningMonitoringSummaries: '今天早晨监控的概况',
    changeInHrFromYesterday: '心率从昨天的变化',
    changeInHrFromFiveDaysAve: '五天平均心率变化',
    differenceInWakingAndStandingHr: '醒来心率和站立心率差异值',
    changeInBodyMassFromYesterday: '体重与昨天比较的变化',
    changeInPerceivedShape: '主观竞技状态的变化',
    hydrationLevel: '补充水分水平',
    trainingQuality: '训练质量',
    theirMostRecentSession: '他们最近的训练课',
    mostRecentSessionWillAppearHere: '的最近的训练课在这里出现。',
    past5Sessions: '我过去的5节训练课',
    pb: '个人最好成绩',
    addData: '增加数据',
    theirNextSession: '他们的下一个训练课',
    doesnHaveNextSessionPlanned: '没有下一个计划的训练课',
    isCurrentlyInNoSquads: '现在不在任何训练小组中。',
    hrWeight: '心率&重量',
    sleepShape: '睡眠&状态',
    kilogram: '千克 | 千克',
    entryBefore: '之前的录入',
    mean: '中间值',
    bodyWeightKg: '身体重量（千克）',
    sleep: '睡眠',
    shape: '状态',
    severelyDehydrated: '严重缺水',
    noHydration: '没有补水',
    thereAreNoNotifications: '没有提示',
    settings: '设置',
    markAllAsRead: '标示所有为已读',
    seeAll: '看所有',
    notificationSettings: '提示设置',
    web: '网页',
    mobile: '手机/平板',
    rowingStats: '划船情况',

    // profile drv
    drv: 'DRV',
    personal: '个人',
    contactInfo: '联系信息',
    degreeAbbreviation: '学位缩写',
    title: '称谓',
    fax: '传真',
    address: '地址',
    street: '街道',
    postCode: '邮编号码',
    state: '州/省',
    city: '城市',
    federationInfo: '协会信息',
    clubInfoAndStatus: '俱乐部信息和状态',
    educationCoachesInfo: '教育，教练员信息',
    myDetails: '我的细节',
    otherDetails: '其他细节',
    rowingDetails: '赛艇细节',
    noResultsWithinDateRange: '在选择的数据范围内没有结果。',
    training: '训练',
    physiology: '生理',
    analysis: '分析',
    trainingAndPerformance: '训练&表现',
    testResultsW: '测试结果(瓦特)',
    trainingVolume: '训练量',
    injuryIllnessTimeline: '受伤&生病时间线',
    trainingVolumes: '训练量',
    enduranceTraining: '耐力训练',
    strengthTraining: '力量训练',
    zone: '训练区域 | 训练区域',
    hour: '小时 | 小时',
    endurance: '耐力',
    trainingCompleted: '训练完成',
    noOfSessions: '训练课的数目',
    trainingLoad: '训练量',
    rowingDistance: '水上训练距离',
    injuries: '受伤',
    illnessTypes: '生病类型',
    injuryTypes: '受伤类型',
    manual: '手册',
    imported: '输入的',
    trainingLoadScore: '训练量分数 | 训练量分数',
    value: '值',
    latestResult: '最近结果',
    latest: '最近',
    pbResult: '个人最好结果',
    planned: '计划的',
    actual: '实际',
    volume: '量 | 量',
    latestMaxLactate: '最近最大乳酸值',
    testScores: '测试结果 | 测试结果',
    vo2Max: '最大摄氧量',
    vo2MaxPerKg: '最大摄氧量/公斤',
    percentage: '百分比',
    latestP2000Index: '最新的2km功率索引',
    latestP6000Index: '最新的6km功率索引',
    trainingZonePercentage: '训练区域百分比',
    spiderDiagram: '蛛网图',
    personalBest: '个人最好成绩',
    mostRecent: '最近',
    average: '平均',

    // reports
    trainingSummary: '训练总结',
    attendanceReportIsEmpty: '出席报告为空',
    selectAthlete: '选择运动员',
    ergoReportIsEmpty: '测功仪报告为空',
    athleteName: '运动员姓名',
    side: '边',
    mainSquad: '主要训练小组',
    bestInPeriod: '该周期内最好',
    firstInPeriod: '该周期内第一',
    lastInPeriod: '该周期内最后',
    change: '改变',
    pbGraph: '个人最好成绩图表',
    doesNotHaveAnySpecificPieces: '没有任何具体的间歇训练做功',
    doesNotHaveAnyPersonalBests: '没有个人最好成绩',
    pieceNo: '间歇训练做功间歇次数',
    wattsKg: '瓦特/公斤',
    rpeScore: '主观难度指数',
    ok: 'OK',
    noData: '没有数据',
    morningMonitoringDefinitions: '早上监控定义',
    hrIncreaseBySevenToTenBeats: '心率增高了7-10次',
    differenceHasNarrowed: '不同值缩小了',
    decreased: '减小了',
    slightlyDehydrated: '轻度脱水',
    between: '在...',
    and: '和...之间',
    hrIncreaseByMoreThanTenBeats: '心率增加了10+',
    injury: '受伤',
    illness: '生病',
    by: '为...值',
    dehydrated: '脱水',
    trafficLights: '交通信号灯',
    wHr: '早晨醒来心率',
    sHr: '站立心率',
    mass: '重量',
    trainingScore: '训练分数',
    yourAthletesMorningMonitoringDataWillAppearHere: '你的运动员早晨监控数据会在这里出现',
    yourAthletesIllnessAndInjuryDataWillAppearHere: '你的运动员生病和受伤数据会在这里出现' + '一旦他们完成了他们的早晨监控',
    yourAthletesQualityOfTrainingWillAppearHere: '你的运动员训练质量会在这里出现' + '一旦他们完成了早晨监控',
    report: '报告',
    athleteErgoProgress: '运动员测功仪进程',
    athleteErgoProgressText:
        '该运动员测功仪进程报告允许你看到他们在历史上的' +
        '在测功仪上的成绩提升。选择一个运动员，你会看到其所有的历史成绩。',
    athleteWaterProgress: '运动员补水状况进程',
    athleteWaterProgressText: '运动员补水状况报告会允许你看到在历史上' + '饮水的情况。在任意一个艇别里察看他们的历史。',
    morningMonitoringText: '早晨监控报告在一个表格上显示选取运动员（们）' + '的早晨监控数据',
    goldMedalTime: '金牌时间',
    goldMedalTimeText:
        '金牌时间报告让你看到每个间歇训练做功时间' +
        '与金牌时间的百分比对照。这个报告也给每个运动员每次做功时间对比金牌时间的平均值做出显示。',
    sessionAttendance: '训练课出席',
    sessionAttendanceText:
        '训练课出席报告会显示运动员训练出席情况' +
        '以及在数据选择范围内训练小组出席情况。这个报告允许你查看过去以及未来的出席情况。',
    ratingPerceivedExertion: '主观训练难度',
    ratingPerceivedExertionText:
        '该报告显示你的每节训练课的运动员主观训练难度' + '此报告显示平均值来看到哪些训练课特别突出。',
    trainingSummaryText:
        '训练总结报告显示运动员完成了多少训练课' +
        '他们的生病/受伤状态，测功仪和GPS数据以及每个运动员计划的训练里程和时间。',
    trainingSummaryReportIsEmpty: '训练总结报告为空',
    trainingSessions: '训练课',
    sessionAttended: '出席的训练课',
    missedDueToIllness: '因生病未出席的训练课',
    missedDueToInjury: '因受伤未出席的训练课',
    missedDueToAbsence: '因其他原因缺席的训练课',
    gpsDataImported: 'GPS数据(倒入的)',
    ergoDataEntered: '测功仪数据(录入的)',
    morningMonitoringCompleted: '晨间监控完成',
    waterReportIsEmpty: '水上报告为空',
    allBoatTypes: '所有艇别',
    export: '导出',
    exportToExcel: '导出到Excel表格',
    aveGmt: '平均金牌时间',
    reportsOverall: '全部',
    rpeReportIsEmpty: '选定区间内主观难度指数为空',
    reset: '重置',
    stepTests: '阶梯测试',
    table: '表格 | 表格',
    graph: '线性图 | 线形图',
    vo2Tests: '最大摄氧量测试',
    k2Tests: '2km测试',
    k6Tests: '6km测试',
    errorsOccurredDuringImport: '导入时出现错误',
    gmtReportIsEmpty: '金牌时间报告在选择的数据范围内为空。',
    teamErgoSummary: '团队测功仪总结',
    teamErgoSummaryText: '团队测功仪汇报会允许你看到在一段周期内运动员的成绩和浆频。',
    teamErgoSummaryIsEmpty: '你的队伍的测功仪结果会在这里出现。团队测功仪总结在选择的日期为空。',
    dataEntered: '录入的数据',
    noResultsForMorningMonitoringReport: '没有晨间监控报告',
    individualView: 'Individual view',
    ergoReport: 'Ergo',
    rowingReport: 'Rowing',
    test: 'Test | Tests',

    // errors
    pageNotFound: '没有找到该页',
    textErrorPage: '请后退，或者寻求援助',
    thereProblem: '这里有一个问题...',
    weWillBeBackSoon: '我们很快回来！',
    text503Page: '我们目前在线下进行维护。我们期待网站在格林威治时间星期一早上9点上线。' + '感谢你的耐心',
    outOfRangeError: '数值一定要在{最小}和{最大}之间',
    redirectingToDashboard: '重新指向到开始页面',
    doNotHavePermissionToSeeAthleteProfile: '你没有查看该运动员的授权。',
    unauthorized: 'Unauthorized',
    unauthorizedErrorPage: "You don't have permission to access this page.",

    // add crew
    addRecent: '加入最近',
    recentCrewsListEmpty: '最近艇组列表为空',
    back: '后退',
    searchAthleteOrDragHere: '搜索运动员或拉到这里',
    showAthletes: '展现运动员',
    hideAthletes: '隐藏运动员',
    boat: '艇 | 艇',
    addingCrewsFor: '为...加上艇组',

    // wall posts
    writeSomethingOnTheWall: '在墙上写一些东西...',

    // billing
    currentPlanInfo: '现在计划信息',
    billingInfo: '收费地址信息',
    transaction: '交易 | 交易',
    annually: '每年付费',
    annual: '每年付费',
    updatePaymentDetails: '上传付款细节',
    addPaymentDetails: '增加付款细节',
    changePlan: '更改计划',
    selectPlan: '选择计划',
    updatePlan: '更新计划',
    plan: '计划',
    perUser: '每个用户',
    for: '为...',
    subscriptionPlan: '订购计划',
    paymentDetails: '付款细节',
    member: '会员 | 会员',
    selectPlanAndAddPayment: '选择计划并加入支付',
    preferredCurrency: '优先货币',
    chooseAPlan: '选择一个计划',
    billedMonthly: '每个月付费',
    perMonth: '每个月',
    billedAnnually: '每年付费',
    perYear: '每年',
    payBy: '付款方式',
    card: '信用卡',
    paymentAmount: '付款总数',
    nameOnCard: '卡上姓名',
    cardNumber: '卡号',
    expiryDate: '过期日期',
    securityCode: '安全保障号码',
    securityCodeTooltip: '卡的背面3位CVC号码',
    zipPostalCode: '邮寄地址邮编号码',
    zipPostalCodeTooltip: '请在这里输入你的邮编号码',
    pay: '付款',
    freeTrial: '免费试用',
    yourClubsFreeTrialExpiresIn: '你的俱乐部免费试用期过期时间为...',
    yourClubsFreeTrialHasExpired: '你的俱乐部免费试用已过期...',
    currency: '货币 | 货币',
    directBankTransfer: '直接银行转账',
    youSubscriptionHasExpired: '你的订购已经过期',
    nextBillDate: '下一个付款日期',
    yourAccountHas: '你的账号有...',
    subscriptionCredit: '订购信用',
    thisWillBeSubtractedFromNextPayment: '这会在下次付费时扣除',
    yourClubCurrentlyDoesNotHaveAPlan: '你的俱乐部现在没有一个订购计划',
    currentPlan: '目前的订购计划',
    youTeamCurrentChargeFor: '你的队伍现在欠费...',
    unlimited: '无限',
    totalCost: '总花费',
    yourSubscriptionExpiredOn: '你的订购过期日期为',
    yourFreeTrialExpiredOn: '你的免费试用到期日期为',
    payHere: '在这里付款',
    cancelSubscription: '取消订购',
    areYouSureToCancelSubscription: '确定你要取消订购么？',
    expiryDateIsInvalid: '过期日期不正确',
    activePlan: '激活的计划',
    planExpired: '过期的计划',
    billingPerUser: '每个用户',
    billingUnlimitedUsers: '无限的用户',
    address1: '第一个地址',
    address2: '第二个地址',

    // billing licence expired
    orSwitchToAnotherClubOnLudum: '或者在Ludum平台上换到另外一个俱乐部',
    sendAdministratorLicenceNotification: '给管理员发送执照提示',
    itLooksLikeYouLicenceHasExpiredWith: '看上去你的执照已经过期',
    clickBelowToSendANotificationToTheClubAdministratorToRenewYouLicence:
        '在以下点击发送提示给' + '俱乐部管理员来更新你的执照',

    // first time user
    welcomeTo: 'Welcome to Ludum',
    firstTimeUserIntoText1:
        '我们欢迎你来到Ludum, 一个专注赛艇训练和组织的' +
        '平台。我们非常高兴帮助你提高训练质量和在水上的速度。',
    firstTimeUserIntoText2: '为了帮助你更好训练、走得更快，请选择你想要如何使用Ludum。',
    asAnAthlete: '运动员',
    AsACoach: '教练',
    withoutAClub: '没有俱乐部',
    useAsIndividual: '作为个人',
    pendingClubs: '俱乐部申请中',

    // onboarding
    welcomeToLudum: '欢迎来到Ludum',
    gettingStartedIntro1:
        '在这个板块里我们介绍如何成功使用Ludum平台。我们注意到了成功完成本版块的俱乐部在水上有更高的成功率。',
    gettingStartedIntro2: '成功的设置你的俱乐部会花费大约5分钟的时间，跟随以下每一步你可以为俱乐部打好成功的基石。',
    gettingStartedIntro3: '如果你有任何问题，请点击右下角的蓝色按钮和我们联系。',
    onboardingYourAgendaInfo1: '我们在这里总结你未来的训练课',
    onboardingYourAgendaInfo2: '这里开始。',
    createASession: '创造一节训练课',
    viewCalendar: '查看日历',
    calendar: '日历',
    onboardingNextSessionInfo: '下节训练课更细节的总结会在这里出现。在你的...查看完全的日程',
    onboardingMostRecentSessionInfo: '你最近的训练课永远会出现在这里。',
    here: '这里',
    onboardingNotificationsInfo1: '在提示中，我们会解释所有与你有关的事情。',
    onboardingNotificationsInfo2: '你可以编辑你的提示设置',
    gettingStarted: '开始',
    gettingStartedShort: '开始',

    // CTL
    ets: 'ETS',
    trimp: 'TRIMP',
    foster: 'Foster',
    scoreRange: '得分区间',
    totalScore: '测试得分',
    noTrainingScoreDataMessage:
        '为什么这里没有数据呢？有两个原因：要么你还没有' +
        '录入训练数据，要么要求的训练量打分还缺少必要的信息，比如' +
        '在Foster打分系统展现感觉或者在TRIMP和ETS输入心率数据。',
    days7: '7天',
    days28: '28天',
    ratio: '比例',
    you: '你',

    // pagination
    perPage: '每一页',
    showing: '显示',
    from: '从...',
    page: '页 | 页',

    // Training Load Scores
    cardiacTrainingLoadScores: '训练分数',
    byWeek: '根据星期',
    byMonth: '根据月份',
    byDay: '根据每天',
    avgScore: '平均分数',
    maxScore: '最大分数',
    minScore: '最小分数',

    // invite member
    addUser: '添加用户',
    inviteAdditionalUsersChargeMessage: '额外的用户可以在下一次付费的时候增加到你的俱乐部内',
    multiInviteAdditionalUsersChargeMessage: '再加入新用户时会导致额外的收费。',

    // first time user
    invitedClubs: '邀请来俱乐部',

    // German import slider
    importDrvFile: '导入DRV数据',
    selectFileToUpload: '选择上传的数据',
    profileImport: '导入档案',
    stepTestImport: '阶梯测试导入',
    vo2TestImport: '最大摄氧量导入',
    k2TestImport: '2km测试',
    k6TestImport: '6km测试',
    importFile: '导入文件',
    row: '水上训练 | 水上训练',

    // step tests
    firstTest: '第一个测试',
    lastTest: '最后一个测试',
    pbOverview: '个人最好成绩纵览',

    // upgrade to Performance
    upgrade: '升级',
    upgradeNow: '现在升级',
    upgradeToPerformance: '升级到高表现',
    upgradeHeader1: '把表现更上一层楼',
    upgradeText1: '为想要增强训练的各方面的教练员和运动员而生' + '增强运动员的<b>高表现</b>体验。',
    upgradeText1_2: '你可以任何时间取消或者是降级',
    upgradeHeader2: '使用<b>第三方软件</b>来把训练更上一层楼',
    upgradeText2:
        '通过导入训练课的<b>GPS</b>和<b>心率</b>数据，' +
        'Ludum可以给你跟多的细节反馈以及更了解自己的训练' +
        '通过<b>自动导入</b>我们能够把Ludum和你最喜欢的第三方平台连接',
    upgradeText2_2: '想要所有的信息都在一个地方么？',
    upgradeHeader3: '<b>细节报告</b>给你所有你需要知道的信息',
    upgradeText3:
        '<i>高表现</i>允许用户对于训练课进行反馈，' +
        '并且可以记录你的表现与之前既定的金牌时间(GMTs)、细节的报告' +
        '核对这些数据并且给以一个容易理解的视觉形式呈现。',
    upgradeText3_2: '需要更多的训练反馈么？',
    upgradeHeader4: '我们有创新性的<b>耐力训练打分系统</b>帮助追踪你的训练量',
    upgradeText4:
        '我们创造了一个对于Ludum平台独创的帮助运动员在一个赛季内' +
        '追踪训练的平台。通过核对心率和训练数据产生一个ETS分数系统' +
        '告诉你需要提升训练量/降低训练量，帮助明白为什么伤病会产生 …xxxx',
    upgradeText4_2: '想要利用最尖端的科技么？',
    upgradeText5: '… 以及更多',
    upgradeHeader6: '交叉训练课',
    upgradeText6: '记录一节交叉训练的数据可以更简单的比较。',
    upgradeHeader7: '每周总结',
    upgradeText7: '看每个星期的训练细节并且周到周做比较。',
    upgradeHeader8: '有竞争性的训练课',
    upgradeText8: '改变训练课的状态，允许运动员看到所有的数据/他们自己的数据。',

    // welcome
    bePartOfATeam: '成为一个队伍的一员',
    getStarted: '开始',
    trainLikePro: '像职业运动员一样训练',
    team: '队伍 | 队伍',
    individual: '个人',
    welcomeToLudumMessage: '请选择你想要如何使用Ludum平台',
    trackYourProgress: '追踪你的进展',
    allInYourHands: '都在手指间',
    organizeYourTeam: '组织你的队伍',
    communicateWithYourTeam: '与你的队伍沟通',
    startUsingLudumToday: '从今天开始使用Ludum',
    startOver: '重新开始',

    // session results
    selectAthleteFromDropdown: '请从下拉菜单选择运动员',
    avePeakForcePosition: 'Ave. Peak Force Position',

    // session attendance
    searchParticipants: '搜索参与运动员',
    listOfAthletesIsEmpty: '运动员列表为空。',
    listOfCoachesIsEmpty: '教练员列表为空。',

    // quick assign
    cannotAddAnythingWhileEverybodyIsSelected: '在所有人员被选定的情况下不能增加任何项目',

    // import data
    noSessions: '没有训练课',

    // Add MM
    sleepTime: '睡眠时间',

    // Notes
    attach: '增加附件',
    noFileInThisNote: '在这个笔记里没有文件',
    fileName: '文件名称',
    delete: '删除',
    byDate: '根据日期',
    asc: '递增顺序',
    desc: '递减顺序',
    areYouSureToRemoveNote: '确定你想要删除此笔记么？',
    addPrivateNoteAboutSession: '增加一个关于本训练课的私人笔记',
    addPrivateNoteAboutEvent: '增加一个关于本事件的私人笔记',
    areYouSureToRemoveFile: '你确定要移除当前文件么？',
    privateNote: 'Private Note | Private Notes',
    addPrivateNote: 'Add Private Note',

    // Search
    search: 'Search',
    searchProfileSquadsEvents: 'Search for profiles, squads and events',
    seeAllSquads: '看所有训练小组',
    seeAllSessions: '看所有训练课',
    seeAllProfiles: '看所有档案',
    event: '事件 | 事件',
    noSearchResults: '没有搜索结果',
    doNotHavePermissionToViewThisPage: '你没有查看此页面的授权。',

    // Create/edit club
    selectCountry: '选择国家',
    selectTimezone: '选择时区',

    // Home
    lastSession: 'Last Session',
    avgSplit: 'Avg. Split',
    vsLast: 'vs. last',
    meter: 'meter | meters',
    trainingIntensity: 'Training Intensity',
    per: 'per',
    backToNotification: 'Back to notification',
    setTime: 'Set time',
    hoursOfSleep: 'Hours Of Sleep',
    sessionToImport: 'Session to import',
    widgetAutoImportSubtitle: 'You have no new sessions to import.',
    widgetAutoImportIntro: 'Your next import will appear here when it is ready.',
    myTraining: 'My Training',
    health: 'Health',
    trainingScores: 'Training Scores',
    noIntensityForThis: 'No intensity for this',
    agenda: 'Agenda',
    unread: 'unread',

    // Login Page
    orLoginWith: 'Or login with',
    alreadyMember: 'Already a member',
    resendActivationEmail: 'Resend activation email',

    // Invitation for membership
    saveYourProfile: 'Save Your Profile',
    cancelThisInvitation: 'cancel this invitation',
    acceptTheInvitation: 'Accept the Invitation',
    wouldYouLikeToJoin: 'Would you like to join',
    hello: 'Hello',
    textInvitedAccount: 'you have been invited to join',
    textInvitedWithAccount1: 'By accepting the invitation',
    textInvitedWithAccount2: 'will be added to your account.',
    textInvitedWithoutAccount: 'By accepting the invitation you can continue to create an account in Ludum.',
    textOnSaveYourProfile: "If you'd like to use Ludum you can continue by saving your profile.",
    invitationAlreadyAccepted: 'Invitation already accepted',
    invitationExpired: 'Invitation expired',

    // Add scores
    sendNotificationAfterSave: 'Send Notification after save',
    viewResultsAfterSave: 'View Results page after save',

    // kayak/canoe
    kayakCanoe: 'Kayak/Canoe',
    rowing: 'Rowing',
    athleteRowingProgress: 'Athlete Rowing Progress',
    athleteRowingProgressText:
        'The athlete rowing progress report will allow you to see the improvements over time your athletes have been ' +
        'making on the water. See a history of their results in each boat type.',

    // default Ludum user
    ludum: 'Ludum',
    user: 'User | Users',

    // Session view results - new
    yourResults: 'Your Results',
    summary: 'Summary',
    imports: 'Imports',
    pieceResults: 'Piece Results',
    piecesSummary: 'Pieces Summary',
    athleteHeartRate: 'Athlete Heart Rate',
    totalReps: 'Total reps',
    typeOfExercises: 'Type of exercises',
    athleteEnduranceTrainingScore: 'Athlete Endurance Training Scores',
    noFilesUploaded: 'No files have been added, please import data',
    showMore: 'Show more',
    crewHr: 'Crew HR',
    noImportedFiles: 'No files have been imported, please import files to view results',
    showAll: 'Show all',
    aveTimeScore: 'Ave. Time Score',
    aveDistanceScore: 'Ave. Distance Score',
    viewResults: 'View Results',

    // Create/edit club
    website: 'Website',
    defaultSport: 'Default sport',
    selectDefaultSport: 'Select default sport',
    unitsOfMeasurement: 'Units of measurement',
    selectUnitsOfMeasurement: 'Select units of measurement',

    // not authorized
    notAuthorizedToSeeThisPage: 'You are not authorized to see this page',

    // titles
    titleLogin: 'Login',
    titleSignUp: 'Sign up',
    titleForgotPassword: 'Forgot password',
    titleHome: 'Home',
    titleDashboard: 'Dashboard',
    titleSession: 'Session',
    titleSessions: 'Sessions',
    titleAddCrews: 'Add crews',
    titleEditCrews: 'Edit crews',
    titleEvent: 'Event',
    titleReports: 'Reports',
    titleSettings: 'Settings',
    titleSquads: '{label}',
    titleClubMembers: 'Club members',
    titleProfile: 'Profile',
    titleLicenceExpired: 'Licence expired',
    titleUpgrade: 'Upgrade',
    titleWelcome: 'Welcome',
    titleSearchResults: 'Search Results',
    titleCrews: 'Crews',
    titleInvitationForMembership: 'Invitation for Membership',
    titleResendActivationEmail: 'Resend activation email',

    // Crews
    saveChanges: 'Save Changes',
    isAlreadyOn: 'is already on',

    /// RPE
    veryEasy: 'Very Easy',
    easy: 'Easy',
    moderate: 'Moderate',
    aBitExhausting: 'A bit exhausting',
    exhausting: 'Exhausting',
    veryExhausting: 'Very Exhausting',
    veryVeryExhausting: 'Very, Very Exhausting',
    maximumEffort: 'Maximum Effort',

    // settings - club list
    areYouSureToDeleteClub: 'Are you sure you want to delete club?',

    // session
    thisSessionBelongsToAnotherClub: 'This session belongs to another club.',
    thisEventBelongsToAnotherClub: 'This event belongs to another club.',

    // rpe
    informationRpeTitle: 'Numbers of stars is equal with number',

    favorite: 'Favorite',

    deleteClub: 'Delete club',
    editClub: 'Edit club',
    youAreAlreadyInThisClub: 'You are already in this club!',
    notificationWillBeSentImmediately: 'Notification will be sent immediately',
    clubEmail: 'Club email',
    clickHereTo: 'Click here to',
    useWithoutClub: 'Use without club',

    allDayEvent: 'All day event',
    tag: 'Tag | Tags',

    // invitation
    invalidFile: 'Invalid file',
    invalidFileType: 'Invalid file type',
    uploadFromFile: 'upload from file',
    sampleFile: 'sample file',
    enterManuallyOr: 'Enter manually or',
    use: 'Use',
    toEasyMakeMultiMembersImport: 'to easy make multi members import',
    chooseFromFileOrDragAndDrop: 'Choose from file or drag and drop',
    added: 'Added',
    error: 'error | errors',
    addMember: 'Add Member',
    resetAll: 'Reset all',
    addNew: 'Add new',
    membersUploadedSuccessfully: 'Members uploaded successfully.',
    userWillBeInvitedToClub: 'User will be invited to club',
    clickToInviteUserToClub: 'Click to invite user to club',

    // session attendance tooltip
    viewAllParticipantsOnThisSession: 'View all participants on this session',

    // Update notification
    webAppUpdated: 'There is a new version of Ludum. Please',
    webAppUpdatedReload: 'Reload',

    // calendar share link
    shareCalendarLink: 'Share Calendar link',
    shareLudumCalendar: 'Share Ludum calendar',
    copyLink: 'Copy link',
    copiedToClipboard: 'Copied to clipboard',
    shareIntroTopTextModal: 'Copy this url to share Ludum calendar with other platforms.',
    read: 'Read',
    tutorial: 'tutorial',
    shareIntroDownTextModal: 'for how to share Ludum calendar.',

    // crews page
    category: 'Category | Categories',
    age: 'Age',
    sportType: 'Sport Type',
    deleteSelectedCrews: 'Delete selected crews',
    noPermission: 'No permission',
    youDontHavePermissionToDeleteThisCrew: "You don't have permission to delete this crew",
    areYouSureToDeleteSelectedCrews: 'Are you sure you want to delete selected crews?',
    crewsSuccessfullyDeleted: 'Crews successfully deleted.',

    // reports - morning monitoring
    numberOfInjuryIllness: 'Number of Injury / Illness',
    ave: 'ave.',
    maxGmtByPiece: 'Max GMT by piece',

    // Team Ergo Summary report
    missingOrIncompleteResults: 'Missing or Incomplete results',
    spm: 'spm',

    // crews
    showFilter: 'Show Filter',
    crewMessageNoData1: 'To add a crew please select a boat from above.',
    crewMessageNoData2: 'Crews will be added to all pieces.',
    publish: 'Publish',
    unpublish: 'Unpublish',
    seatRacing: 'Seat racing',
    youHaveToSelectCrewFirst: 'You have to select a crew first.',
    thereAreNoCrews: 'There are no crews',

    // home widget
    noSquadsInThisClub: 'No {label} in this club',
    addSquads: 'Add {label}',

    // Resend activation email
    resendActivationEmailIntroText:
        'Your user account has not been activated yet. Please check your email to verify your account.',

    // finish club setup - notification
    finishClubSetup: 'It is recommended to finish club setup on a desktop computer.',

    // create session/event further action modal
    saveAndCreateNew: 'Save and Create new',
    saveAndExit: 'Save and exit',
    returnToSessionCreate: 'Return to session create',
    addCrews: 'Add Crews',

    profileImage: 'Profile image',

    // team report
    kaizenTeam: 'Kaizen Team',
    kaizenTeamText:
        'The Kaizen Team report gives you the power to compare the rate of improvement of your athletes over time.',
    noAthleteOrSquadMessage:
        'Welcome to the Kaizen Team Report, this report gives you the power to compare the rate ' +
        'of improvement of your athletes over time.<br><br>' +
        'It also includes the added dimension of comparing this to the actual training load done by each athlete.<br>' +
        'In order to show some data please select some athletes either by name or by selecting a Squad. ' +
        'Then pick a date range that is of interest to you.',
    pleaseSelectAthlete: 'Please select athlete',
    trainingTime: 'Training Time',
    sessionsCompleted: 'Session completed',
    sessionsMissed: 'Sessions missed',
    sessionDate: 'Session date',
    percentageImprovement: 'Percentage improvement',
    meanPercentageOfGroup: 'Mean Percentage of group',
    maxPercentageOfGroup: 'Max Percentage of group',
    cumulativeImprovement: 'Cumulative Improvement',
    noTrainingLoadScoreData: 'No training load score data',
    noPercentageImprovementData: 'No percentage improvement data',
    perWeek: '/w',
    structure: 'Structure | Structures',
    cumulativeImprovementTooltip:
        'This graph shows the improvement of each athlete on the indoor rowing machine over ' +
        'the date range selected. The improvement is produced by comparing like for like sessions, and calculating ' +
        'the improvement (in watts) between the two. This means we are able to compare two athletes improvement ' +
        'even if they do different Ergometer Sessions.',
    trainingLoadScoreTooltip:
        'Here you can see the change in training load of every athlete you select, ' +
        'over the date range you have chosen.<br><br>' +
        'There are four type of Training load on offer on this graph.<br>' +
        '    1. ETS – Endurance Training Score<br>' +
        '    2. Trimp – Training Impulse<br>' +
        '    3. Foster – RPE x training time<br>' +
        '    4. RPE – Rate of Perceived Effort',
    athletesSummaryTooltip:
        'A list of all athletes you have selected displaying the total training time, the total ' +
        'number of sessions completed as well as the number that have been missed. We also display the total and ' +
        'weekly average of the Training Load Score you selected in the top Graph. The overall improvement is also ' +
        'put here to compare improved performance to training.',
    individualSummaryTooltip:
        'Once you select a particular athlete from your group, then we display all the ' +
        'ergometer sessions that were completed in that date range.  We show the improvement for each session as ' +
        'well as the running total improvement. Also for comparison we show the mean and max improvement for ' +
        'that given session.',
    individualResults: 'Individual results',
    showCrew: 'Show crew',

    sessionInfo: 'Session info',

    quickAssignInfo:
        'In order to make it easier to create training sessions for many people in one go we have developed the ' +
        'quick assign feature. Please enter the name of a squad or a list of people into this box then simply drag ' +
        'and drop sport types, recent sessions or favourites into the day and time you want the session to happen. ' +
        'All those names will be assigned to those sessions and the session structures will also be transposed from ' +
        'the recents and favourites.',

    messageFooterPublicPages: 'Your training history only begins the day you start collecting your training data.',
    morningMonitoringLog: 'Morning Monitoring Log',
    privacySettings: 'Privacy Settings',
    allCoaches: 'All Coaches',
    specificCoaches: 'Specific Coaches',
    allCoachesExcept: 'All Coaches except',
    onlyMe: 'Only me',
    whoCanSeeMyProfileAndReports: 'Who can see my profile and reports?',
    float: 'Float',
    garmin: 'Garmin',
    polar: 'Polar',
    suunto: 'Suunto',
    select: 'Select',

    // Equipment List.
    equipmentList: 'Equipment List',
    allEquipment: 'All Equipment',
    equipmentCategory: 'Equipment Category',
    categoryName: 'Category name',
    enterNameOfNewCategory: 'Enter name of new category',
    addCategory: 'Add Category',
    editCategory: 'Edit Category',
    deleteCategory: 'Delete Category',
    areYouSureToDeleteCategory: 'Are you sure you want to delete this category?',
    addEquipment: 'Add Equipment',
    noEquipment1: 'No equipment. Click to',
    noEquipment2: 'to add on list of equipment.',
    noCategory1: 'No category. Click to',
    noCategory2: 'to add equipment category.',
    searchByNameOrSerialNumber: 'Search by name or serial number',
    serialNumber: 'Serial number',
    dateBought: 'Date Bought',
    dateSold: 'Date Sold',
    minimaxSpecific: 'Minimax specific',
    hardwareSettings: 'Hardware settings',
    samplingRates: 'Sampling rates',
    totalRunningTime: 'Total running time',
    correctionFactors: 'Correction factors',
    unitIntegrity: 'Unit integrity',
    dataStorageCapacity: 'Data storage capacity',
    memoryAvailable: 'Memory available',
    accuracyFactors: 'Accuracy factors',
    lastLog: 'Last Log',
    viewAllLogs: 'View all logs',
    batteryStatus: 'Battery status',
    deleteEquipment: 'Delete Equipment',
    removeEquipment: 'Remove Equipment',
    areYouSureToRemoveEquipment: 'Are you sure you want to remove this equipment?',
    assignEquipment: 'Assign Equipment',
    assignDevice: 'Assign device',
    assignedBy: 'Assigned by',

    // Challenges.
    challenge: 'Challenge | Challenges',
    viewMore: 'View more',
    allChallenges: 'All Challenges',
    addChallenge: 'Add Challenge',
    addTeam: 'Add Team',
    info: 'Info',
    teamInfo: 'Team Info',
    myTeams: 'My Teams',
    maximum: 'maximum',
    athletesPerTeam: 'athletes per team',
    myTeamResults: 'My Team Results',
    searchByTeamName: 'Search by Team Name ',
    created: 'Created',
    numberOfMembers: 'No. Of Members',
    editChallenge: 'Edit Challenge',
    deleteChallenge: 'Delete Challenge',
    teamName: 'Team Name',
    enterNameOfNewTeam: 'Enter Name of New Team',
    areYouSureToRemoveChallengeTeam: 'Are you sure you want to remove this challenge team?',
    addChallenges: 'Add Challenges',
    currentChallenges: 'Current Challenges',
    futureChallenges: 'Future Challenges',
    pastChallenges: 'Past Challenges',
    teamsLimitation: 'Teams Limitation',
    visitLudum: 'Visit Ludum',
    totalNoOfStrokes: 'Total No. of Strokes',
    pos: 'Pos.',
    poweredBy: 'Powered by',
    challengeBoardInfoText:
        'Ludum enables you and your team to keep winning and achieving better results through the power of ' +
        'performance data, better organisation and smooth communication. Empower athletes to train at the right ' +
        'intensity levels, helping to prevent injury and illness and get the edge that sets the winners apart ' +
        'from others, while a coach has a convenient way of adapting training plans to achieve high performance and ' +
        'a steady athlete development pace.',
    aveStrokeRate: 'Ave. Stroke Rate',
    howToUseChallenges: 'How to use challenges',
    step: 'Step',
    challengeStep1Text: 'Login or Sign up on',
    challengeStep2Text: 'Select Challenge and "Add Team"',
    challengeStep3Text: 'and connect to Ludum',
    download: 'Download',
    floatApp: 'Float app',
    thereAreNoAthletes: 'There are no athletes',
    endTime: 'End Time',
    noOfHeartbeats: 'No. of Heartbeats',
    publicChallengesHowToUseTitle: 'Challenges for all',
    publicChallengesHowToUseSubTitle: 'Compete or Complete with more sports',
    publicChallengesHowToUseText1: 'Ludum Challenges offers the most innovative series of challenges, appealing to those who want to compete or complete. Whether you want to run, swim, cycle or row indoors, we have it here for you!',
    publicChallengesHowToUseText2: 'Compete: Pit yourself against other individuals or teams to see how you compare',
    publicChallengesHowToUseText3: 'Complete: Test your own determination. It does not matter what your level of performance is you can still be at the top of the leaderboard.',
    publicChallengesHowToUseText4: 'Challenges will be for specific sports or all sports.',
    publicChallengesHowToUseText5: 'See our',
    publicChallengesHowToUseText5Link: 'Challenges Guide',
    publicChallengesHowToUseSportTypes: 'Sport Types',
    publicChallengesHowToUseSportTypesText: 'Swimming, Running, Cycling, Rowing Indoors',
    publicChallengesHowToUseCompete: 'Compete',
    publicChallengesHowToUseCompeteText: 'fastest, higher, stronger',
    publicChallengesHowToUseComplete: 'Complete',
    publicChallengesHowToUseCompleteText: 'most time, most distance, most strokes (Indoor Rowing), most heartbeats (all Sports)'
};
